/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Privacyconsentrequired3Inputs */

const en_newpatient_privacyconsentrequired3 = /** @type {(inputs: Newpatient_Privacyconsentrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must agree to the Privacy Policy to continue.`)
};

const fr_newpatient_privacyconsentrequired3 = /** @type {(inputs: Newpatient_Privacyconsentrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous devez accepter la Politique de confidentialité pour continuer.`)
};

/**
* | output |
* | --- |
* | "You must agree to the Privacy Policy to continue." |
*
* @param {Newpatient_Privacyconsentrequired3Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_privacyconsentrequired3 = /** @type {((inputs?: Newpatient_Privacyconsentrequired3Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Privacyconsentrequired3Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_privacyconsentrequired3(inputs)
	return fr_newpatient_privacyconsentrequired3(inputs)
});
export { newpatient_privacyconsentrequired3 as "newPatient_privacyConsentRequired" }